export const SET_DASHBOARD_TOTALS = 'SET_DASHBOARD_TOTALS'
export const SET_DASHBOARD_CATEGORY_TOTALS = 'SET_DASHBOARD_CATEGORY_TOTALS'
export const SET_DASHBOARD_WORKVIEWS = 'SET_DASHBOARD_WORKVIEWS'
export const SET_DASHBOARD_GRAPH_DATA = 'SET_DASHBOARD_GRAPH_DATA'
export const SET_DASHBOARD_GRAPH_SUBCATEGORIES = 'SET_DASHBOARD_GRAPH_SUBCATEGORIES'
export const SET_DASHBOARD_LAST_DAYS = 'SET_DASHBOARD_LAST_DAYS'
export const SET_DASHBOARD_CURRENT_MONTH = 'SET_DASHBOARD_CURRENT_MONTH'
export const SET_DASHBOARD_CURRENT_YEAR = 'SET_DASHBOARD_CURRENT_YEAR'
export const SET_DASHBOARD_LAST_YEARS = 'SET_DASHBOARD_LAST_YEARS'
export const SET_USERS = 'SET_USERS'
export const SET_USER_PRODUCTIVITY_DATA = 'SET_USER_PRODUCTIVITY_DATA'
export const SET_DATED_USER_PRODUCTIVITY_DATA = 'SET_DATED_USER_PRODUCTIVITY_DATA'
export const SET_DASHBOARD_QUEUE_DATA = 'SET_DASHBOARD_QUEUE_DATA'

const initialState = {
  totals: {},
  categoryTotals: {},
  workviews: [],
  graphData: [],
  subCategories: [],
  lastDays: [],
  currentMonth: [],
  currentYear: [],
  lastYears: [],
  users: [],
  userData: {},
  datedUserData: [],
  queueData: {},
}

// map to single object with DatePart as key
const mapTotalsArrayToSingleObject = (totals) => {
  const mappedData = {}
  totals.forEach((item) => {
    mappedData[item.DatePart] = item
  })
  return mappedData
}

const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DASHBOARD_TOTALS:
      return {
        ...state,
        // totals: action.totals.map(total => ({ [total.DatePart]: total })),
        totals: mapTotalsArrayToSingleObject(action.totals),
      }
    case SET_DASHBOARD_CATEGORY_TOTALS:
      return {
        ...state,
        categoryTotals: action.totals,
      }
    case SET_DASHBOARD_WORKVIEWS:
      return {
        ...state,
        workviews: action.workviews,
      }
    case SET_DASHBOARD_GRAPH_DATA:
      return {
        ...state,
        graphData: action.graphData,
      }
    case SET_DASHBOARD_GRAPH_SUBCATEGORIES:
      return {
        ...state,
        subCategories: action.subCategories,
      }
    case SET_DASHBOARD_LAST_DAYS:
      return {
        ...state,
        lastDays: action.lastDays,
      }
    case SET_DASHBOARD_CURRENT_MONTH:
      return {
        ...state,
        currentMonth: action.currentMonth,
      }
    case SET_DASHBOARD_CURRENT_YEAR:
      return {
        ...state,
        currentYear: action.currentYear,
      }
    case SET_DASHBOARD_LAST_YEARS:
      return {
        ...state,
        lastYears: action.lastYears,
      }
    case SET_USERS:
      return {
        ...state,
        users: action.users,
      }
    case SET_USER_PRODUCTIVITY_DATA:
      return {
        ...state,
        userData: action.userData,
      }
    case SET_DATED_USER_PRODUCTIVITY_DATA:
      return {
        ...state,
        datedUserData: action.datedUserData,
      }
    case SET_DASHBOARD_QUEUE_DATA:
      return {
        ...state,
        queueData: action.queueData,
      }
    default:
      return state
  }
}

export default DashboardReducer
